module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/montserrat-light-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/montserrat-light-webfont.ttf
// module id = 344
// module chunks = 0